import PropTypes from 'prop-types'
import {
  Select as MuiSelect,
  InputLabel,
  FormHelperText,
  FormControl,
  InputAdornment,
  CircularProgress,
} from '@mui/material'

import useStyles from './styles'

const Select = ({
  disabled,
  isRequired,
  error,
  labelId,
  label,
  helperText,
  loading,
  children,
  className,
  sx,
  MenuProps: menuPropsModifier,
  ...props
}) => {
  const classes = useStyles()

  return (
    <FormControl
      disabled={disabled}
      error={error}
      className={className}
      sx={sx}
    >
      <InputLabel required={isRequired} id={labelId}>
        {label}
      </InputLabel>
      <MuiSelect
        {...props}
        MenuProps={{
          classes: {
            paper: 'select-menu',
          },
          ...menuPropsModifier,
        }}
        endAdornment={
          loading ? (
            <InputAdornment className={classes.adornment} position="end">
              <CircularProgress
                className={classes.circularProgress}
                size={20}
              />
            </InputAdornment>
          ) : null
        }
      >
        {children}
      </MuiSelect>
      {helperText ? (
        <FormHelperText error={error}>{helperText}</FormHelperText>
      ) : null}
    </FormControl>
  )
}

Select.propTypes = {
  loading: PropTypes.bool,
  children: PropTypes.node.isRequired,
  isRequired: PropTypes.bool,
  disabled: PropTypes.bool,
  error: PropTypes.bool,
  labelId: PropTypes.string.isRequired,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  helperText: PropTypes.string,
  className: PropTypes.string,
  sx: PropTypes.object,
  MenuProps: PropTypes.object,
}

export default Select
